module.exports = __webpack_public_path__ + "media/img/photo2-a5d03634.png";